
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"infoPanel.address":"Adresse","infoPanel.attributes":"Attribute"},"en":{"infoPanel.address":"Address","infoPanel.attributes":"Attributes"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();